module.exports = __webpack_public_path__ + "img/light-touch-clinic-social-media-management.b17b35fb.jpg";